import { ResourceData } from "../../../../../types/resource";

export const RESOURCES: ResourceData[] = [
  {
    name: "EndCoronaVirus (ECV)",
    description:
      "ECV is an international volunteer coalition that develops and promotes community-based solutions for policy-makers, businesses and individuals.",
    url: "https://www.endcoronavirus.org/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/endcoronavirus-ecv.jpg",
  },
  {
    name: "Masks4All",
    description:
      "#Masks4All is an all-volunteer org spreading the overwhleming science that homemade masks can slow the spread of COVID-19, save lives, and help restore the economy.",
    url: "https://masks4all.co/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/masks4all.png",
  },
  {
    name: "COVID-19 Projections",
    description:
      "We take a data-driven approach rooted in epidemiology to forecast infections and deaths from the COVID-19 epidemic in the US and around the world.",
    url: "https://covid19-projections.com/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/covid-19-projections.png",
  },
  {
    name: "The COVID Tracking Project",
    description:
      "The public deserves the most complete data available about COVID-19 in the US. No official source is providing it, so we are.",
    url: "https://covidtracking.com/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/covid-tracking-project.png",
  },
  {
    name: "COVID Exit Strategy",
    description:
      "We identify critical interventions needed to stop the spread of and urge the United States government decision-makers to apply them.",
    url: "https://www.covidexitstrategy.org/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/covidexitstrategy.png",
  },
  {
    name: "The COVID Racial Data Tracker",
    description:
      "COVID-19 is affecting people of color the most. We're gathering the most complete race and ethnicity data on COVID-19 in the US.",
    url: "https://covidtracking.com/race",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/covid-race-tracking-project.png",
  },
  {
    name: "Covid Act Now",
    description:
      "A tool to help leaders and communities understand how the pandemic will affect regions across the USA.",
    url: "https://covidactnow.org/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/covid-actnow.png",
  },
  {
    name: "JHU CSSE COVID-19 World Dashboard",
    description:
      "Johns Hopkins University and CSSE’s COVID-19 World Dashboard created to help track the pandemic in real time.",
    url: "https://coronavirus.jhu.edu/map.html",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/johns-hopkins-dashboard.jpg",
  },
  {
    name: "Bing COVID-19 Tracker",
    description:
      "Comprehensive, easy to use pandemic dashboard with the latest COVID-19 statistics for your country and relevant news and updates.",
    url: "https://www.bing.com/covid",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/bing-covid19-tracker.png",
  },
  {
    name: "Rt Covid-19",
    description:
      "An up-to-date tracker of how fast COVID-19 is spreading in each US state. When Rt is below 1.0, the virus will stop spreading. ",
    url: "https://rt.live/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/rt-covid-19.png",
  },
  {
    name: "Worldometers",
    description:
      "Plain and simple, real-time statistics on the global COVID-19 pandemic.",
    url: "https://www.worldometers.info/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/worldometers.png",
  },
  {
    name: "Epidemic Calculator",
    description:
      "This epidemic calculator can help you understand what will happen under different scenarios of conditions.",
    url: "https://gabgoh.github.io/COVID/index.html",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/epidemic-calculator.png",
  },
  {
    name: "Our World In Data",
    description:
      "Coronavirus Data Explorer. It brings together global data on testing for COVID-19, and the counts of confirmed cases and deaths.",
    url: "https://ourworldindata.org/coronavirus",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/owid-covid-19-data-explorer.jpg",
  },
  {
    name: "World Health Organization",
    description:
      "WHO is the United Nations’ health agency and is working towards coordinating the global efforts on combatting the COVID-19 crisis.",
    url: "https://www.who.int/",
    imageUrl: "https://askabout.io/media/images/covid-19-resource/who.jpg",
  },
  {
    name: "Centers for Disease Control & Prevention",
    description:
      "US based CDC works 24/7 to protect people’s health and is providing best practice guidelines for responding to the COVID-19 pandemic.",
    url: "https://www.cdc.gov/",
    imageUrl: "https://askabout.io/media/images/covid-19-resource/cdc.jpg",
  },
  {
    name: "US Economic Tracker",
    description:
      "Track the economic impacts of COVID-19 on people, businesses, and communities across the United States in real time.",
    url: "https://tracktherecovery.org/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/us-economic-tracker.png",
  },
  {
    name: "Which countries are beating COVID-19?",
    description:
      "Some are winning and some are not. Find out which ones are beating COVID-19 and keeping case numbers low.",
    url: "https://www.endcoronavirus.org/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/end-coronavirus.png",
  },
  {
    name: "Smart Air - Research around face masks",
    description:
      "Explore data driven research on whether masks actually work, how long they last, how to wash them, and how to DIY your own mask.",
    url: "https://smartairfilters.com/en/blog/category/masks/",
    imageUrl:
      "https://askabout.io/media/images/covid-19-resource/smart-air.png",
  },
];
